module.exports = __webpack_public_path__ + "static/museum.cd06d78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/museum.png
// module id = 311
// module chunks = 168707334958949